var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLangSv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 136.94 95.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke-width: 0px;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.37,81.12c5.22-5.5,5.67-15.44,2.85-22.05-3.94-9.22-7.18-8.55-7.84-16.68-.7-8.57,7.48-13.55,5.65-26.77-2.03-14.69-18.38-22.45-33.8-7.72-20.61,19.7-44.93.9-46.66-.3C29.13-8.59,3.94,14.2,7.4,30.99c1.13,5.5,4.13,13.82.67,22.16-3.16,7.63-13.04,23.35-4.99,33.7,4.51,5.79,12.43,6.88,19.24,5.09,8.4-2.21,23.28-16.21,32.33-12.12,7.72,3.48,8.18,6.92,14.35,12.54,5.88,5.36,17.51,4.39,23.98-2.3,4.03-4.16,6.21-5.77,12.46-6.61,8.79-1.19,16.59,8.54,26.91-2.33Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GtayQv.tif"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Layer_0",
    "data-name": "Layer 0",
    width: 1600,
    height: 1000,
    transform: "translate(-9.64 -2.09) scale(.1)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKEAAABlCAYAAAAlKIMUAAAACXBIWXMAAAsSAAALEgHS3X78AAABeUlEQVR4nO3doU2DURiG0f8HBI6EKSqqsN2jI9Tgm47Q1GOaYJDsUYuq6Bo4DIEFwN3kCeScAd584sm1d5ogNt89vn7VR4ywX5ynzeowbO942k67y3LYHj97f1rPV/URIEJyIiQnQnIiJCdCciIkJ0JyIiQnQnIiJCdCciIkJ0JyIiQnQnIiJCdCciIkJ0JyIiQnQnIiJCdCciIkJ0JyIiQnQnIiJCdCciIkJ0JyIiQnQnIiJCdCciIkJ0JyIiQ3f77d/ot/TPibrh8+/GNCT4TkREhOhORESE6E5ERIToTkREhOhORESE6E5ERIToTkREhOhORESE6E5ERI7ub++aW+YYj94jxtVodhe8fTdtpdlsP2+M3aS0hPhORESE6E5ERIToTkREhOhORESE6E5ERIToTkREhOhORESE6E5ERIToTkREhOhORESE6E5ERIToTkREhOhORESE6E5ERIToTkREhOhORESE6E5ERIToTkREhOhORESO4byQIWcNIYEPsAAAAASUVORK5CYII="
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangSv);
export default __webpack_public_path__ + "static/media/lang-sv.d88a16cc52297f01474f2cf607a0a387.svg";
export { ForwardRef as ReactComponent };